module.exports = __webpack_public_path__ + "media/images/logo-small-e12c459f9df3741f74f896199ef56516.png";